import "./fonts";
import Architektur from "./Architektur";
import Handwerk from "./Handwerk";
import Restaurant from "./Restaurant";
import Immobilien from "./Immobilien";
import Beauty from "./Beauty";
import Fitness from "./Fitness";
import Steuer from "./Steuer";
import Hotel from "./Hotel";
import Fahrzeug from "./Fahrzeug";
import Coaching from "./Coaching";

export const SITES = {
  architektur: Architektur,
  handwerk: Handwerk,
  restaurant: Restaurant,
  immobilien: Immobilien,
  beauty: Beauty,
  fitness: Fitness,
  steuer: Steuer,
  hotel: Hotel,
  fahrzeug: Fahrzeug,
  coaching: Coaching,
};
